
export class Utils {
      static getInitials(name: string): string {
        if (!name) return 'UU'; // Caso o nome não esteja disponível
    
        const nameParts = name.split(' ');
    
        if (nameParts.length > 1) {
          // Se houver mais de um nome, use a primeira letra do primeiro nome e a primeira letra do último nome
          return nameParts[0][0].toUpperCase() + nameParts[nameParts.length - 1][0].toUpperCase();
        } else {
          // Se houver apenas um nome, use a primeira e a última letra
          return name[0].toUpperCase() + name[name.length - 1].toUpperCase();
        }
    }
}
    